var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "table-responsive",
        on: {
          contextmenu: function($event) {
            $event.preventDefault()
            return _vm.$refs.ctxMenu.open($event)
          }
        }
      },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/vuetable-2-kernel/compiled/template/contextualMenu.vue?vue&type=template&id=dcd49fee&
// module id = null
// module chunks = 